export const isRtl = (locale) => {
  const rtlLocales = ['ar', 'he'];
  return rtlLocales.includes(locale);
};

export const getTranslations = (languageConfig, locale) => {
  if (!locale) {
    return languageConfig['en-GB'];
  }

  // get by full locale if it exists
  if (languageConfig[locale]) {
    return languageConfig[locale];
  }

  // get by language if it exists
  const language = locale.split('-')[0];
  if (languageConfig[language]) {
    return languageConfig[language];
  }

  // default to english
  return languageConfig['en-GB'];
};
